<p-tabView>
  <p-tabPanel header="Hồ sơ hóa đơn điện tử">
    <form [formGroup]="form" (ngSubmit)="onSubmit()" autocomplete="off">
      <div class="p-field p-col-12 p-text-right p-mb-0">
        <div *ngIf="!updating">
          <p-button label="{{ 'Edit'|translate }}" icon="pi pi-pencil" styleClass="p-button-raised p-button-warning" (onClick)="update()"
                    *ngIf="AuthService.hasPrivilege('OrganizationInfo', 'OrganizationInfo1', 'UPDATE')"></p-button>
        </div>
        <div *ngIf="updating">
          <p-button label="{{ 'Close'|translate }}" icon="pi pi-times" styleClass="p-button-raised p-button-outlined p-button-secondary" (onClick)="cancelUpdate()"></p-button>
          <p-button label="{{ 'Update'|translate }}" icon="pi pi-check" styleClass="p-button-raised p-ml-2" type="submit" [disabled]="submitted"></p-button>
        </div>
      </div>
      <div class="p-fluid p-formgrid p-grid detail">

        <div class="p-field p-col-12">
          <p-fieldset legend="{{ 'Thông tin đơn vị'|translate }}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-3">
                <label for="partyTaxId">{{ (isHouseholdBusinessType() ? 'CCCD' : ('TaxCode'|translate)) }}<span class="required">*</span></label>
                <input pInputText type="text" id="partyTaxId" formControlName="partyTaxId">
                <app-validator [control]="form.get('partyTaxId')"></app-validator>
              </div>
              <div class="p-field p-col-12 p-md-3">
                <label for="businessType">{{ 'Hình thức kinh doanh'|translate }}<span class="required">*</span></label>
                <p-dropdown id="businessType" [options]="businessTypes" formControlName="businessType" [autoDisplayFirst]="false" placeholder="-" (onChange)="onBusinessTypeChange()"></p-dropdown>
                <app-validator [control]="form.get('businessType')"></app-validator>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="partyName">{{ 'OrganizationName'|translate }}<span class="required">*</span></label>
                <input pInputText type="text" id="partyName" formControlName="partyName">
                <app-validator [control]="form.get('partyName')"></app-validator>
              </div>
              <ng-container *ngIf="isHouseholdBusiness()">
                <div class="p-field p-col-12">
                  <div class="p-field-checkbox">
                    <p-checkbox formControlName="isMultiFacility" [binary]="true" inputId="isMultiFacility" (onChange)="onMultiFacilityChange()"></p-checkbox>
                    <label for="isMultiFacility">{{ 'Hộ kinh doanh có nhiều địa điểm kinh doanh'|translate }}</label>
                    <p-button *ngIf="form.get('isMultiFacility')?.value" label="{{ 'Cấu hình địa điểm kinh doanh'|translate }}" icon="pi pi-cog"
                              styleClass="p-button-outlined p-button-sm p-ml-3" (onClick)="openFacilityDialog()" [disabled]="!updating"></p-button>
                  </div>
                </div>
                <ng-container *ngIf="!form.get('isMultiFacility')?.value">
                  <div class="p-field p-col-12 p-md-3">
                    <div class="business-location-label-row">
                      <label for="facilityPseudoId" class="business-location-label">{{ 'Mã địa điểm kinh doanh'|translate }}<span class="required">*</span></label>
<!--                      <a [href]="businessLocationGuideUrl" target="_blank" rel="noopener noreferrer"-->
<!--                         class="business-location-guide-link business-location-guide-link&#45;&#45;inline"-->
<!--                         [title]="'Hướng dẫn tra cứu Mã địa điểm KD'|translate">-->
<!--                        <i class="pi pi-question-circle"></i> <span class="business-location-guide-link__text">{{ 'Hướng dẫn tra cứu Mã địa điểm KD'|translate }}</span>-->
<!--                      </a>-->
                    </div>
                    <input pInputText type="text" id="facilityPseudoId" formControlName="facilityPseudoId" maxlength="5">
                    <app-validator [control]="form.get('facilityPseudoId')"></app-validator>
                  </div>
                  <div class="p-field p-col-12 p-md-3">
                    <label for="facilityName">{{ 'Tên địa điểm kinh doanh'|translate }}<span class="required">*</span></label>
                    <input pInputText type="text" id="facilityName" formControlName="facilityName" maxlength="400">
                    <app-validator [control]="form.get('facilityName')"></app-validator>
                  </div>
                  <div class="p-field p-col-12 p-md-6">
                    <label for="facilityAddress">{{ 'Địa chỉ địa điểm kinh doanh'|translate }}<span class="required">*</span></label>
                    <input pInputText type="text" id="facilityAddress" formControlName="facilityAddress" maxlength="400">
                    <app-validator [control]="form.get('facilityAddress')"></app-validator>
                  </div>
                </ng-container>
              </ng-container>
              <div class="p-field p-col-12 p-md-3">
                <label for="emailAddress">{{ 'Email'|translate }}</label>
                <input pInputText type="email" id="emailAddress" formControlName="emailAddress" [email]="true">
                <app-validator [control]="form.get('emailAddress')"></app-validator>
              </div>
              <div class="p-field p-col-12 p-md-3">
                <label for="phoneNumber">{{ 'Phone'|translate }}</label>
                <input id="phoneNumber" pInputText type="text" formControlName="phoneNumber" [maxlength]="20">
                <app-validator [control]="form.get('phoneNumber')"></app-validator>
              </div>
              <div class="p-field p-col-12 p-md-3">
                <label for="faxNumber">{{ 'FaxNumber'|translate }}</label>
                <input pInputText type="text" id="faxNumber" formControlName="faxNumber">
              </div>
              <div class="p-field p-col-12 p-md-3">
                <label for="webAddress">{{ 'WebAddress'|translate }}</label>
                <input pInputText type="text" id="webAddress" formControlName="webAddress">
                <app-validator [control]="form.get('webAddress')"></app-validator>
              </div>
              <div class="p-field p-col-12 p-md-3">
                <label for="stateProvinceGeoId">{{ 'Province'|translate }}<span class="required">*</span></label>
                <p-dropdown id="stateProvinceGeoId" [options]="provinces" [filter]="true" formControlName="stateProvinceGeoId"></p-dropdown>
                <app-validator [control]="form.get('stateProvinceGeoId')"></app-validator>
              </div>
              <div class="p-field p-col-12 p-md-3">
                <app-county-geo [abstractControl]="form.get('wardGeoId')" [stateProvinceGeoId]="form.get('stateProvinceGeoId')?.value"></app-county-geo>
                <app-validator [control]="form.get('wardGeoId')"></app-validator>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="address1">{{ 'Địa chỉ đăng ký kinh doanh'|translate }}<span class="required">*</span></label>
                <input pInputText type="text" id="address1" formControlName="address1">
                <app-validator [control]="form.get('address1')"></app-validator>
              </div>
            </div>
          </p-fieldset>
        </div>

        <div class="p-field p-col-12">
          <p-fieldset legend="{{ 'Representative'|translate }}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <label for="representativeName">{{ 'RepresentativeName'|translate }}</label>
                <input pInputText type="text" id="representativeName" formControlName="representativeName">
                <app-validator [control]="form.get('representativeName')"></app-validator>
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="representativeJobTitle">{{ 'RepresentativeJobTitle'|translate }}</label>
                <input pInputText type="text" id="representativeJobTitle" formControlName="representativeJobTitle">
                <app-validator [control]="form.get('representativeJobTitle')"></app-validator>
              </div>
              <div class="p-field p-col-12 p-md-3">
                <label for="representativeEmail">{{ 'Email'|translate }}</label>
                <input pInputText type="email" id="representativeEmail" formControlName="representativeEmail" [email]="true">
                <app-validator [control]="form.get('representativeEmail')"></app-validator>
              </div>
              <div class="p-field p-col-12 p-md-3">
                <label for="representativePhoneNumber">{{ 'Phone'|translate }}</label>
                <input id="representativePhoneNumber" pInputText type="text" formControlName="representativePhoneNumber" [maxlength]="20">
              </div>
            </div>
          </p-fieldset>
        </div>
        <div class="p-field p-col-6">
          <p-fieldset legend="{{ 'Thông tin cơ quan thuế chủ quản'|translate }}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-col-12 p-md-6">
                <app-tax-authority [abstractControl]="form.get('taxAuthorityId')" [stateProvinceGeoId]="form.get('stateProvinceGeoId')?.value"></app-tax-authority>
              </div>
            </div>
          </p-fieldset>
        </div>
        <div class="p-field p-col-6">
          <p-fieldset legend="{{ 'Thông tin thanh toán'|translate }}">
            <div class="p-fluid p-formgrid p-grid">
              <div class="p-field p-col-12 p-md-6">
                <label for="bankAccount">{{ 'BankAccount'|translate }}</label>
                <input [maxlength]="30" pInputText type="text" id="bankAccount" formControlName="bankAccount">
              </div>
              <div class="p-field p-col-12 p-md-6">
                <label for="bankName">{{ 'BankName'|translate }}</label>
                <input pInputText type="text" id="bankName" formControlName="bankName">
              </div>
            </div>
          </p-fieldset>
        </div>
      </div>
    </form>
  </p-tabPanel>
  <p-tabPanel header="Tình trạng hợp đồng">
    <ng-template pTemplate="content">
      <app-consume-review></app-consume-review>
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Tờ khai TT78" *ngIf="decreeCircular === 'DecCir78'">
    <ng-template pTemplate="content">
      <app-message-100-accepted></app-message-100-accepted>
    </ng-template>
  </p-tabPanel>
  <p-tabPanel header="Lịch sử thay đổi">
    <ng-template pTemplate="content">
      <app-changelogs></app-changelogs>
    </ng-template>
  </p-tabPanel>
</p-tabView>

<p-dialog header="{{ 'Cấu hình địa điểm kinh doanh'|translate }}" [(visible)]="displayFacilityDialog" [modal]="true" [style]="{width: '70vw'}" styleClass="business-location-dialog">
  <ng-template pTemplate="header">
    <div class="business-location-dialog-header">
      <span class="p-dialog-title">{{ 'Cấu hình địa điểm kinh doanh'|translate }}</span>
<!--      <a [href]="businessLocationGuideUrl" target="_blank" rel="noopener noreferrer" class="business-location-guide-link">-->
<!--        <i class="pi pi-question-circle"></i> {{ 'Hướng dẫn tra cứu Mã địa điểm KD'|translate }}-->
<!--      </a>-->
    </div>
  </ng-template>
  <div class="p-mb-2 p-text-right">
    <p-button label="{{ 'Add'|translate }}" icon="pi pi-plus" styleClass="p-button-outlined p-button-sm" (onClick)="addFacilityRow()"></p-button>
  </div>
  <p-table [value]="dialogFacilityList" styleClass="p-datatable-sm p-datatable-striped p-datatable-gridlines business-location-table">
    <ng-template pTemplate="header">
      <tr>
        <th style="width: 40px" class="p-text-center">#</th>
        <th style="width: 12%">{{ 'Mã địa điểm'|translate }}</th>
        <th style="width: 33%">{{ 'Tên địa điểm'|translate }}</th>
        <th style="width: 55%">{{ 'Địa chỉ địa điểm'|translate }}</th>
        <th style="width: 60px" class="p-text-center">{{ 'Chính'|translate }}</th>
        <th style="width: 60px"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData let-index="rowIndex">
      <tr>
        <td class="p-text-center">{{ index + 1 }}</td>
        <td><input class="business-location-input" pInputText type="text" [(ngModel)]="rowData.pseudoId" [ngModelOptions]="{standalone: true}" maxlength="5"></td>
        <td><input class="business-location-input" pInputText type="text" [(ngModel)]="rowData.facilityName" [ngModelOptions]="{standalone: true}" maxlength="400"></td>
        <td><input class="business-location-input" pInputText type="text" [(ngModel)]="rowData.address1" [ngModelOptions]="{standalone: true}" maxlength="400"></td>
        <td class="p-text-center">
          <p-checkbox [binary]="true" [ngModel]="isPrimaryFacility(rowData)" [ngModelOptions]="{standalone: true}" (onChange)="setPrimaryFacility(index, $event)"></p-checkbox>
        </td>
        <td class="p-text-center">
          <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger p-button-sm" (onClick)="deleteFacilityRow(index)"></p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <div class="business-location-note p-mt-3">
    <span class="business-location-note__hint">
      <strong>{{ 'Lưu ý'|translate }}:</strong>
      {{ 'Vui lòng bỏ tích tại cột'|translate }} <strong>{{ 'Là địa điểm kinh doanh chính'|translate }}</strong>
      {{ 'để sửa thành địa điểm kinh doanh khác.'|translate }}
    </span>
    <div class="p-field-checkbox p-mt-2 p-mb-0">
      <p-checkbox [(ngModel)]="facilityTermsAccepted" [binary]="true" inputId="facilityTermsAccepted" [ngModelOptions]="{standalone: true}"></p-checkbox>
      <label for="facilityTermsAccepted">{{ 'Tôi xác nhận và chịu hoàn toàn trách nhiệm về việc cập nhật Mã địa điểm kinh doanh.'|translate }}</label>
    </div>
  </div>
  <p-footer>
    <p-button label="{{ 'Close'|translate }}" icon="pi pi-times" styleClass="p-button-raised p-button-text p-button-plain" (onClick)="displayFacilityDialog=false"></p-button>
    <p-button label="{{ 'Save'|translate }}" icon="pi pi-check" styleClass="p-button-raised" (onClick)="saveFacilityDialog()"></p-button>
  </p-footer>
</p-dialog>
